import React, { Component } from 'react'

export default class FactoryMenu extends Component{
  render(){
  	const {children} = this.props
	  return(
	  	<div className="hud-map__pointers">
			{ children }
	  	</div>
	  )
  }
}
